import React from "react";
import styles from "./index.module.scss";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { convertDateTime } from "../../Helpers/date";
import moment from "moment";

function InternalNoteAccordion(props) {
  const [expanded, setExpanded] = React.useState(true);

  return (
    <div className={`${styles.InternalNotesAccordianStyle}`}>
      <Accordion
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
        className={`${styles.MuiAccordion}`}
      >
        <AccordionSummary
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className={`${styles.summary} Custom-Accordian`}
        >
          <div
            className={`${styles.iconArrow} ${
              props.panel === expanded && styles.iconRotation
            }`}
          >
            <KeyboardArrowUpIcon style={{ color: "#ffffff" }} />
          </div>
          <p className={`${styles.author}`}>{props.data.author}</p>
          <p className={`${styles.time}`}>
            {props.data.time && props.data.time !== null
              ? convertDateTime(moment(props.data.time).toISOString(), 'iso', 'ccc LLL dd, yyyy, hh:mm a')
              : ""}
          </p>
        </AccordionSummary>
        <AccordionDetails className={`${styles.desc}`}>
          {props.data.ans}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default InternalNoteAccordion;
